import dynamic from 'next/dynamic';
import { twMerge } from 'tailwind-merge';

import Body from './Body';
import Footer from './Footer';
import Heading from './Heading';
import Margin from './Margin';

const Sidebar = dynamic(() => import('./Sidebar'));

const ScrollToTopButtonBase = dynamic(
  () => import('components/ScrollToTopButton'),
  { ssr: false }
);

const ScrollToTop = ({ className, ...props }) => (
  <ScrollToTopButtonBase
    className={twMerge('col-span-full', className)}
    {...props}
  />
);

const FlatLayout = {
  Body,
  Footer,
  Heading,
  Margin,
  Sidebar,
  ScrollToTop,
};

export default FlatLayout;
